import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useConfig } from "@/context/ConfigContext";
import { Button } from "@/components/ui/button";
import { Menu, X, ShieldCheck } from "lucide-react";

export const Header = () => {
  const { config } = useConfig();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  const links = [
    { to: "/#fonctionnement", label: "Fonctionnement" },
    { to: "/#garanties", label: "Garanties" },
    { to: "/#accompagnement", label: "Le courtier" },
    { to: "/#faq", label: "FAQ" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <header className="glass-header sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20 md:h-24">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-logo">
          {config.logo_url ? (
            <img src={config.logo_url} alt={config.brand_name} className="h-12 md:h-16 w-auto" />
          ) : (
            <span className="flex items-center gap-2 font-display font-extrabold text-brand-navy text-lg">
              <ShieldCheck className="text-blue-700" size={24} /> {config.brand_name}
            </span>
          )}
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a key={l.label} href={l.to} className="text-sm font-medium text-slate-600 hover:text-blue-700 transition-colors">
              {l.label}
            </a>
          ))}
          <Button variant="outline" size="sm" onClick={() => nav("/espace-courtier")} data-testid="crm-access-button">
            Espace courtier
          </Button>
        </nav>

        <button className="md:hidden text-slate-700" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white px-4 py-4 space-y-3">
          {links.map((l) => (
            <a key={l.label} href={l.to} onClick={() => setOpen(false)} className="block text-slate-700 font-medium py-1">
              {l.label}
            </a>
          ))}
          <Button variant="outline" className="w-full" onClick={() => nav("/espace-courtier")}>
            Espace courtier
          </Button>
        </div>
      )}
    </header>
  );
};
